import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import AppLayout from "@/components/AppLayout";
import Overview from "@/pages/Overview";
import Finance from "@/pages/Finance";
import Fields from "@/pages/Fields";
import Slots from "@/pages/Slots";
import Payments from "@/pages/Payments";
import Todos from "@/pages/Todos";
import Members from "@/pages/Members";
import EmailSettings from "@/pages/EmailSettings";
import { Loader2 } from "lucide-react";


function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <Protected>
                  <AppLayout />
                </Protected>
              }
            >
              <Route index element={<Overview />} />
              <Route path="finans" element={<Finance />} />
              <Route path="sahalar" element={<Fields />} />
              <Route path="slotlar" element={<Slots />} />
              <Route path="odemeler" element={<Payments />} />
              <Route path="gorevler" element={<Todos />} />
              <Route path="eposta" element={<EmailSettings />} />
              <Route path="uyeler" element={<Members />} />

            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
